import { KEYS, NAMESPACE } from "./i18n/actionName.i18n";
import { ACTION_TYPE } from "Types/automationTypes";

export function getActionName($app, actionType) {
    //find the key that matches the passed type
    const foundActionTypeKey = Object.keys(ACTION_TYPE).find((key) => ACTION_TYPE[key] === actionType);
    const key = KEYS[foundActionTypeKey];
    if (key) {
        return $app.res({ namespace: NAMESPACE, key });
    }
    return null;
}
